import React from "react";
import EmployeeDismissalsGenericSkeleton from "./EmployeeDismissalsGenericSkeleton";

function EmployeeDismissalsDetailSkeleton() {
  return (
    <>
      <EmployeeDismissalsGenericSkeleton />
    </>
  );
}

export default EmployeeDismissalsDetailSkeleton;
